"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createRawBuildingPacket = void 0;
const lumos_1 = require("@ckb-lumos/lumos");
const resolvedInputs_1 = require("./resolvedInputs");
function createRawBuildingPacket(props) {
    const txSkeleton = props.txSkeleton;
    return {
        type: 'BuildingPacketV1',
        value: {
            message: {
                actions: props.actions ?? [],
            },
            payload: lumos_1.helpers.createTransactionFromSkeleton(txSkeleton),
            resolvedInputs: (0, resolvedInputs_1.inputCellsToResolvedInputs)(txSkeleton.get('inputs')),
            changeOutput: props.changeOutput ?? txSkeleton.get('outputs').size - 1,
            scriptInfos: props.scriptInfos ?? [],
            lockActions: [],
        },
    };
}
exports.createRawBuildingPacket = createRawBuildingPacket;
//# sourceMappingURL=buildingPacket.js.map